module.exports = __webpack_public_path__ + "img/loading-blobs.9330cc9b.svg";